import { gql } from '@apollo/client';

const USER_TOKEN = gql`
    query GetToken {
        token @client
    }
`;

export default USER_TOKEN;
